'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var core = require('@reactables/core');
var operators = require('rxjs/operators');
var rxjs = require('rxjs');
var forms = require('@reactables/forms');
var utilities = require('@jauntin/utilities');

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var emptyAddress = {
    address: '',
    city: '',
    state: '',
    zip: ''
};
var emptyAddress2 = __assign(__assign({}, emptyAddress), { address2: '' });
var address = function (_a, required) {
    var _b = _a === void 0 ? emptyAddress : _a, address = _b.address, city = _b.city, state = _b.state, zip = _b.zip;
    if (required === void 0) { required = true; }
    return forms.group({
        controls: {
            address: forms.control([address, required ? ['required'] : []]),
            city: forms.control([city, required ? ['required'] : []]),
            state: forms.control([state, required ? ['required'] : []]),
            zip: forms.control({
                initialValue: zip,
                validators: ['zipCode'].concat(required ? 'required' : []),
                normalizers: ['normalizeZip']
            })
        }
    });
};
var address2Group = function (_a, required) {
    if (_a === void 0) { _a = emptyAddress2; }
    var address2 = _a.address2, address1 = __rest(_a, ["address2"]);
    if (required === void 0) { required = true; }
    return forms.group({
        controls: __assign(__assign({}, address(address1, required).controls), { address2: forms.control([address2]) })
    });
};

var googlePlaceRequired = function (googleVenue) { return ({
    googlePlaceRequired: !Boolean(googleVenue === null || googleVenue === void 0 ? void 0 : googleVenue.address)
}); };
var venueCompanyNameRequired = function (googleVenue) { return ({
    venueCompanyNameRequired: (googleVenue === null || googleVenue === void 0 ? void 0 : googleVenue.address) && !Boolean(googleVenue.address.companyName)
}); };
var googleVenueConfig = forms.control([
    null,
    ['googlePlaceRequired', 'venueCompanyNameRequired'],
]);
var manualVenueConfig = forms.group({
    controls: {
        name: forms.control(['', ['required']]),
        address: address()
    }
});
var addVenueForm = forms.group({
    controls: {
        googleVenue: googleVenueConfig
    }
});

var uploadForm = forms.group({
    validators: ['notEditing'],
    controls: {
        contact: forms.group({
            controls: {
                firstAndLastName: forms.control(['', 'required']),
                jobTitle: forms.control(['']),
                email: forms.control(['', ['required', 'email']]),
                phoneNumber: forms.control({
                    initialValue: '',
                    validators: ['required', 'phoneNumber'],
                    normalizers: ['normalizePhone']
                })
            }
        }),
        defaultContact: forms.group({
            controls: {
                email: forms.control(['', ['email']]),
                copyOnEmails: forms.control([false])
            }
        }),
        venueList: forms.control([[], 'arrayNotEmpty'])
    }
});

var formConfig = forms.group({
    controls: {
        addVenueForm: addVenueForm,
        uploadForm: uploadForm
    }
});

var addVenueReducers = {
    addVenue: function (_a, // Built in FormReducers provided by RxForms
    /**
     * Use these reducers to update form state to maintain the integrity of
     * the form tree (i.e validation states of parent and children controls).
     */
    state) {
        var updateValues = _a.updateValues, resetControl = _a.resetControl;
        var form = state.form;
        var venue = form.addVenueForm.value;
        var venueListItem;
        if (venue.googleVenue) {
            var _b = venue.googleVenue.address, address1 = _b.address1, city = _b.city, state_1 = _b.state, zip = _b.zip, companyName = _b.companyName;
            var address = {
                address: address1,
                city: city,
                state: state_1,
                zip: zip
            };
            venueListItem = {
                name: companyName,
                address: address,
                contacts: [],
                additionalInsured: {
                    name: '',
                    address: __assign(__assign({}, emptyAddress), { address2: '' })
                },
                googlePlaceId: venue.googleVenue.placeId
            };
        }
        else {
            var _c = venue.manualVenue, name_1 = _c.name, address = _c.address;
            venueListItem = {
                name: name_1,
                address: address,
                contacts: [],
                additionalInsured: {
                    name: '',
                    address: __assign(__assign({}, emptyAddress), { address2: '' })
                },
                googlePlaceId: null
            };
        }
        var venueListRef = ['uploadForm', 'venueList'];
        state = updateValues(state, {
            controlRef: venueListRef,
            value: form[venueListRef.join('.')].value.concat(venueListItem)
        });
        state = resetControl(state, ['addVenueForm']);
        return state;
    },
    toggleSearchType: function (_a, state) {
        var addControl = _a.addControl, removeControl = _a.removeControl;
        var form = state.form;
        var googleVenueRef = ['addVenueForm', 'googleVenue'];
        var manualVenueRef = ['addVenueForm', 'manualVenue'];
        var isGoogleSearchOn = Boolean(form[googleVenueRef.join('.')]);
        state = removeControl(state, isGoogleSearchOn ? googleVenueRef : manualVenueRef);
        state = addControl(state, {
            controlRef: isGoogleSearchOn ? manualVenueRef : googleVenueRef,
            config: isGoogleSearchOn ? manualVenueConfig : googleVenueConfig
        });
        return state;
    },
    clearGoogleSearch: function (_a, state) {
        var resetControl = _a.resetControl;
        return resetControl(state, ['addVenueForm.googleVenue']);
    }
};

var venueContact = function (contact) {
    if (contact === void 0) { contact = { email: '', copyOnEmails: false }; }
    return forms.group({
        controls: {
            email: forms.control([contact.email, ['required', 'email']]),
            copyOnEmails: forms.control([contact.copyOnEmails])
        }
    });
};

var editVenue = function (_a, index) {
    var name = _a.name, address$1 = _a.address, additionalInsured = _a.additionalInsured, contacts = _a.contacts, googlePlaceId = _a.googlePlaceId;
    return forms.group({
        controls: {
            index: forms.control([index]),
            venue: forms.group({
                controls: {
                    name: forms.control([name, 'required']),
                    address: address(address$1),
                    contacts: forms.array({
                        controls: contacts.map(function (contact) { return venueContact(contact); })
                    }),
                    googlePlaceId: forms.control([googlePlaceId]),
                    additionalInsured: forms.group({
                        controls: {
                            name: forms.control([additionalInsured.name]),
                            address: forms.group({
                                controls: __assign(__assign({}, address2Group(additionalInsured.address, false).controls), { zip: forms.control({
                                        initialValue: additionalInsured.address.zip,
                                        validators: ['facilityOtherAdditionalInsuredZipCode'],
                                        normalizers: ['normalizeZipPlus4']
                                    }) })
                            })
                        }
                    })
                }
            })
        }
    });
};

var editVenueReducers = {
    addVenueContact: function (_a, state) {
        var pushControl = _a.pushControl;
        var contactsRef = ['uploadForm', 'editVenue', 'venue', 'contacts'];
        if (state.form[contactsRef.join('.')].value.length < 5) {
            state = pushControl(state, {
                controlRef: contactsRef,
                config: forms.group({
                    controls: {
                        email: forms.control(['', ['required', 'email']]),
                        copyOnEmails: forms.control([false])
                    }
                })
            });
        }
        return state;
    },
    editVenue: function (_a, state, _b) {
        var addControl = _a.addControl;
        var index = _b.payload;
        var venue = state.form['uploadForm.venueList'].value[index];
        state = addControl(state, {
            controlRef: ['uploadForm', 'editVenue'],
            config: editVenue(venue, index)
        });
        return state;
    },
    saveVenue: function (_a, state) {
        var removeControl = _a.removeControl, updateValues = _a.updateValues;
        var form = state.form;
        var venueListRef = ['uploadForm', 'venueList'];
        var _b = form['uploadForm.editVenue'].value, newVenue = _b.venue, index = _b.index;
        var newVenueList = state.form[venueListRef.join('.')].value.map(function (venue, i) {
            if (i === index) {
                return newVenue;
            }
            else {
                return venue;
            }
        });
        state = updateValues(state, {
            controlRef: venueListRef,
            value: newVenueList
        });
        state = removeControl(state, ['uploadForm', 'editVenue']);
        return state;
    },
    clearAdditionalInsured: function (_a, state) {
        var updateValues = _a.updateValues;
        return updateValues(state, {
            controlRef: ['uploadForm', 'editVenue', 'venue', 'additionalInsured'],
            value: {
                name: '',
                address: emptyAddress2
            }
        });
    },
    cancelEdit: function (_a, state) {
        var removeControl = _a.removeControl;
        return removeControl(state, ['uploadForm', 'editVenue']);
    }
};

var removeVenueReducers = {
    removeVenue: function (_a, state, _b) {
        var updateValues = _a.updateValues, removeControl = _a.removeControl;
        var removeIndex = _b.payload;
        var venueListRef = ['uploadForm', 'venueList'];
        var newList = state.form[venueListRef.join('.')].value.filter(function (_, index) { return index !== removeIndex; });
        state = updateValues(state, {
            controlRef: ['uploadForm', 'venueList'],
            value: newList
        });
        if (state.form['uploadForm.editVenue']) {
            state = removeControl(state, ['uploadForm', 'editVenue']);
        }
        return state;
    }
};

var validatorFns = function () {
    return Object.entries(utilities.validators).reduce(function (acc, _a) {
        var _b;
        var key = _a[0], validator = _a[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = function (value) {
            var _a;
            return (_a = {},
                _a[key] = Boolean(validator(value, undefined)),
                _a);
        }, _b)));
    }, {});
};

var RxVenueUploadForm = function (options) {
    return forms.build(formConfig, __assign(__assign({ name: 'rxVenueUploadForm' }, options), { 
        // Reducers for custom form behaviour
        reducers: __assign(__assign(__assign({}, addVenueReducers), editVenueReducers), removeVenueReducers), providers: {
            // Provide validators when initializing the form
            validators: __assign(__assign({}, validatorFns()), { googlePlaceRequired: googlePlaceRequired, venueCompanyNameRequired: venueCompanyNameRequired, notEditing: function (value) { return ({
                    notEditing: Boolean(value.editVenue)
                }); } }),
            normalizers: utilities.normalizers
        } }));
};

var lodableInitialState = {
    loading: false,
    data: null,
    success: false,
    error: null
};
var load = function (state) { return (__assign(__assign({}, state), { loading: true })); };
var loadSuccess = function (state, action) { return (__assign(__assign({}, state), { loading: false, data: (action === null || action === void 0 ? void 0 : action.payload) || null, success: true })); };
var loadError = function (state, action) { return (__assign(__assign({}, state), { loading: false, success: false, error: action.payload })); };

var RxToggle = function (initialState) {
    if (initialState === void 0) { initialState = false; }
    return core.RxBuilder({
        initialState: initialState,
        reducers: {
            toggleOn: function () { return true; },
            toggleOff: function () { return false; },
            toggle: function (state) { return !state; }
        }
    });
};

var RxVenueUploader = function (venueUploadService, _a) {
    var uploadId = _a.uploadId, debug = _a.debug;
    // Observable to fetch facilityInfo
    var loadFacility$ = rxjs.from(venueUploadService.loadFacilityInfo(uploadId)).pipe(operators.map(function (_a) {
        var data = _a.data;
        return ({
            type: 'loadFacilitySuccess',
            payload: data
        });
    }), operators.catchError(function (error) {
        return rxjs.of({ type: 'loadFacilityFailure', payload: error });
    }));
    // Rx manages loading of Facility Info
    var rxFacilityInfo = core.RxBuilder({
        name: 'rxFacilityInfo',
        initialState: __assign(__assign({}, lodableInitialState), { loading: true }),
        debug: debug === null || debug === void 0 ? void 0 : debug.facilityInfo,
        sources: [loadFacility$],
        reducers: {
            loadFacilitySuccess: loadSuccess,
            loadFacilityFailure: loadError
        }
    });
    // Rx manages form state and validations
    var rxForm = RxVenueUploadForm({ debug: debug === null || debug === void 0 ? void 0 : debug.form });
    // Rx manages "editingContact" state
    var rxEditContactToggle = RxToggle(true);
    // Rx manages form submission
    var rxSubmission = core.RxBuilder({
        name: 'rxSubmission',
        initialState: lodableInitialState,
        debug: debug === null || debug === void 0 ? void 0 : debug.submission,
        reducers: {
            submitForm: {
                reducer: load,
                effects: [
                    function (submission$) {
                        return submission$.pipe(operators.mergeMap(function (_a) {
                            var payload = _a.payload;
                            return rxjs.from(venueUploadService.uploadVenues(uploadId, payload)).pipe(operators.map(function () { return ({ type: 'submitSuccess' }); }), operators.catchError(function (error) {
                                return rxjs.of({
                                    type: 'submitFailure',
                                    payload: error
                                });
                            }));
                        }));
                    },
                ]
            },
            submitSuccess: loadSuccess,
            submitFailure: loadError
        }
    });
    // Combine states of reactables
    var state$ = rxjs.combineLatest({
        form: rxForm[0],
        facilityInfo: rxFacilityInfo[0],
        submission: rxSubmission[0],
        editingContact: rxEditContactToggle[0]
    });
    // Expose public action methods
    var actions = {
        form: rxForm[1],
        submit: rxSubmission[1].submitForm,
        toggleContactEdit: rxEditContactToggle[1].toggle
    };
    return [state$, actions];
};

exports.RxToggle = RxToggle;
exports.RxVenueUploader = RxVenueUploader;
exports.load = load;
exports.loadError = loadError;
exports.loadSuccess = loadSuccess;
exports.lodableInitialState = lodableInitialState;
exports.validatorFns = validatorFns;
